import PropTypes from 'prop-types';
import React from 'react';

import { DefaultAlert, Button } from 'twyne-new.ui';

const AlertPlacement = ({ show, onClick }) => {
  if (!show) {
    return null;
  }

  return (
    <DefaultAlert
      variant="warning"
      title="Placement Modified"
      icon={false}
      className='mt-4'
    >
      <p>
        The content of the placement has been modified in the Advanced tab. To restore to the original generated placement, click the restore button below. All customizations will be lost.
      </p>
      <Button className='mt-4' color="accent" onClick={onClick}>Restore Standard Placement</Button>
    </DefaultAlert>
  );
};

AlertPlacement.propTypes = {
  show: PropTypes.bool,
  onClick: PropTypes.func,
}

export default AlertPlacement;
